import React, { useState } from 'react';

import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
} from 'recharts';

import { formatDate } from 'helpers/date';

const tooltipWrapperStyles = {
  backgroundColor: 'rgba(0,0,0,.85)',
  fontsize: '14px',
  color: '#fff',
  borderRadius: '4px',
};

const UnloadingDepthChart = ({ stats, syncId, tzOffset, ...rest }) => {
  const [visibility, setVisibility] = useState({
    lastDepthFormatted: true,
    lastDepthAdjustedFormatted: true,
    lastDepthAvgPredFormatted: true,
    lastDepthPredMMFormatted: false,
    lastDepthRawFormatted: false,
    last10MinSegOnly: true,
  });

  let minDepth = 0, maxDepth = 0;
  const data = stats.map((stat, i) => {
    stat = { ...stat };
    stat.lastDepthFormatted = Number(stat.last_depth).toFixed(3);
    stat.lastDepthAdjustedFormatted = Number(stat.last_depth_adjusted).toFixed(3);
    stat.lastDepthAvgPredFormatted = Number(stat.last_depth_avg_pred).toFixed(3);
    stat.lastDepthPredMMFormatted = Number(stat.last_depth_predicted_mm).toFixed(3);
    stat.lastDepthRawFormatted = Number(stat.last_depth_raw).toFixed(3);
    stat.last10MinSegOnly = Number(stat.seg_only_last_10min).toFixed(3);

    minDepth = Math.min(
      minDepth,
      stat.lastDepthFormatted,
      stat.lastDepthAdjustedFormatted,
      stat.lastDepthAvgPredFormatted,
      stat.lastDepthPredMMFormatted,
      stat.lastDepthRawFormatted,
      stat.last10MinSegOnly
    );
    maxDepth = Math.max(
      maxDepth,
      stat.lastDepthFormatted,
      stat.lastDepthAdjustedFormatted,
      stat.lastDepthAvgPredFormatted,
      stat.lastDepthPredMMFormatted,
      stat.lastDepthRawFormatted,
      stat.last10MinSegOnly
    );
    return stat;
  });

  maxDepth = Math.ceil(maxDepth);

  return (
    <ResponsiveContainer width="100%" height={350} {...rest}>
      <ComposedChart data={data} syncId={syncId}>
        <CartesianGrid strokeDasharray="3 3" stoke="#E7F3F8" />
        <XAxis dataKey="dt_datetime" minTickGap={15} tickMargin={10} stroke="#2F454E" tickFormatter={value => {
          return formatDate(Date.parse(value), 'HH:mm', {
            tzOffset
          });
        }} />

        <YAxis yAxisId="depth" type="number" stroke="#2F454E" strokeWidth="1" domain={[minDepth, maxDepth]}>
          <Label value="Depth" position="insideLeft" angle={-90} offset={10} />
        </YAxis>

        <Tooltip contentStyle={tooltipWrapperStyles}
          labelFormatter={label => formatDate(Date.parse(label), 'yy-MM-dd HH:mm', {
            tzOffset
          })}
        />
        <Legend verticalAlign="top" height={46} onClick={({ dataKey }) => {
          setVisibility({ ...visibility, [dataKey]: !visibility[dataKey] });
        }} />

        <Line yAxisId="depth" name="Last Depth" hide={!visibility.lastDepthFormatted} type="monotone" dataKey="lastDepthFormatted" dot={false} activeDot={true} stroke="#FADB14" strokeWidth="2" />
        <Line yAxisId="depth" name="Last Depth Adjusted" hide={!visibility.lastDepthAdjustedFormatted} type="monotone" dataKey="lastDepthAdjustedFormatted" dot={false} activeDot={true} stroke="#95DE64" strokeWidth="2" />
        <Line yAxisId="depth" name="Last Depth Avg Predicted" hide={!visibility.lastDepthAvgPredFormatted} type="monotone" dataKey="lastDepthAvgPredFormatted" dot={false} activeDot={true} stroke="#87E8DE" strokeWidth="2" />
        <Line yAxisId="depth" name="Last Depth Predicted MM" hide={!visibility.lastDepthPredMMFormatted} type="monotone" dataKey="lastDepthPredMMFormatted" dot={false} activeDot={true} stroke="#85A5FF" strokeWidth="2" />
        <Line yAxisId="depth" name="Last Depth Raw" type="monotone" hide={!visibility.lastDepthRawFormatted} dataKey="lastDepthRawFormatted" dot={false} activeDot={true} stroke="#FF7875" strokeWidth="2" />
        <Line yAxisId="depth" name="Last 10 min Seg Only" type="monotone" hide={!visibility.last10MinSegOnly} dataKey="last10MinSegOnly" dot={false} activeDot={true} stroke="#F5232D" strokeWidth="2" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default UnloadingDepthChart;
